/* global trak */
const trackingFunctionExists = func =>
  typeof trak !== 'undefined' && typeof trak[func] === 'function';

export const init = (obj = {}) => {
  if (!trackingFunctionExists('init')) {
    return;
  }

  try {
    trak.init(obj);
  } catch (e) {
    // TODO log to sentry?
  }
};

export const view = (value, firstLoaded = false) => {
  if (!trackingFunctionExists('view')) {
    return;
  }

  try {
    if (value) {
      trak.view(value, firstLoaded);
    } else {
      trak.view(window.location.pathname, firstLoaded);
    }
  } catch (e) {
    // TODO log to sentry?
  }
};

export default function event(eventName, params) {
  if (!trackingFunctionExists('event')) {
    return;
  }

  try {
    trak.event({
      mp: [
        {
          type: 'track',
          key: eventName,
          params,
        },
      ],
    });
  } catch (e) {
    // TODO log to sentry?
  }
}

export const dimension = obj => {
  if (!trackingFunctionExists('dimension')) {
    return;
  }

  try {
    trak.dimension(obj);
  } catch (e) {
    // TODO log to sentry?
  }
};

export const reloadDataAttributeElement = () => {
  if (!trackingFunctionExists('reloadDataAttributeElement')) {
    return;
  }

  try {
    trak.reloadDataAttributeElement();
  } catch (e) {
    // TODO log to sentry?
  }
};
